export default __webpack_public_path__ + "static/media/Group 11002.1edfeb38.svg";